import { IS_EMBEDDED } from '@sketch/constants';
import { GetDocumentListSettingsDocument, GetAnnotationSettingsDocument, GetBrowserSettingsDocument } from '@sketch/gql-types';

const initializeLocalApolloState = (cache) => {
    // Initialize the DocumentLayout grid setting on cache
    cache.writeQuery({
        query: GetDocumentListSettingsDocument,
        data: {
            __typename: 'RootQueryType',
            documentsLayout: 'GRID',
            showDocumentsInProjects: true,
        },
    });
    // Initialize the Annotation settings on cache
    cache.writeQuery({
        query: GetAnnotationSettingsDocument,
        data: {
            __typename: 'RootQueryType',
            hideAnnotationsDots: false,
        },
    });
    // Initialize user settings on cache
    cache.writeQuery({
        query: GetBrowserSettingsDocument,
        data: {
            __typename: 'RootQueryType',
            sidebarRightOpen: !IS_EMBEDDED,
        },
    });
};

export { initializeLocalApolloState };
